import {
  MultipleSelectionProperty,
  FormPageInputItem,
  FormPageInputItemMultipleSelection,
  FormPageInputItemMultipleSelectionCheckbox,
  INPUT_ITEM_TYPE,
  MULTIPLE_SELECTION_PROPERTY_INPUT_TYPE,
} from 'shared';

type Subtexts = FormPageInputItemMultipleSelectionCheckbox['subtexts'];
const convertSubtexts = (
  candidates: MultipleSelectionProperty['candidates'],
  inputItemSubtexts?: Subtexts
): Subtexts => {
  return candidates
    .filter(({ subtext }) => subtext)
    .map((candidate) => {
      const inputItemSubtext = inputItemSubtexts?.find(
        ({ value }) => value === candidate.value
      );
      return (
        inputItemSubtext ?? {
          value: candidate.value,
          subtext: '',
        }
      );
    });
};

const handleCheckbox = (
  property: MultipleSelectionProperty,
  formPageInputItem?: FormPageInputItem
): FormPageInputItemMultipleSelectionCheckbox => {
  const inputItemType = INPUT_ITEM_TYPE.multipleSelectionCheckbox;
  const { candidates } = property;
  if (
    formPageInputItem?.inputItemType ===
    INPUT_ITEM_TYPE.multipleSelectionCheckbox
  ) {
    const subtexts = convertSubtexts(candidates, formPageInputItem.subtexts);
    const values = formPageInputItem.values?.filter((value) =>
      candidates.some((candidate) => candidate.value === value)
    );
    return {
      inputItemType,
      values,
      subtexts,
    };
  }
  const { defaultSelectedValues } = property.inputFormat;

  return {
    inputItemType,
    values: defaultSelectedValues ?? undefined,
    subtexts: convertSubtexts(candidates),
  };
};

export const convertMultipleSelectionInitialValue = (
  property: MultipleSelectionProperty,
  formPageInputItem?: FormPageInputItem
): FormPageInputItemMultipleSelection => {
  const { checkbox } = MULTIPLE_SELECTION_PROPERTY_INPUT_TYPE;
  switch (property.inputFormat.inputType) {
    case checkbox:
      return handleCheckbox(property, formPageInputItem);
  }
};
